import { DatatableConfig } from "src/app/config/DatatableConfig";
import { FormControl, FormBuilder } from "@angular/forms";
import {
  Observable,
  startWith,
  map,
  debounceTime,
  distinctUntilChanged,
} from "rxjs";
import { IListaAnhos, IListaPeriodos } from "src/app/interfaces/ponderaciones";
import { HistoricoCalificacionesService } from "src/app/services/historico-calificaciones/historico-calificaciones.service";
import { Component, OnInit } from "@angular/core";
import { IListaReportes } from "src/app/interfaces/reporte-historico-calificaciones";
import { saveAs } from 'file-saver';

@Component({
  selector: "app-view-reporte-historico-calificaciones",
  templateUrl: "./view-reporte-historico-calificaciones.component.html",
  styleUrls: ["./view-reporte-historico-calificaciones.component.scss"],
})
export class ViewReporteHistoricoCalificacionesComponent implements OnInit {
  dtOptions: DataTables.Settings = { ...DatatableConfig.dtOptionDefaultSearchLeft };
  rutEstudiante: string = "";
  filtroAnyoSeleccionado: number = 0;
  filtroAnyos: Array<number> = [];
  filtroPeriodos: Array<any> = [];
  filtroIdSeccion: Array<any> = [];
  filtroPeriodoSeleccionado: number = 0;
  filtroIdSeleccionado: number = 0;

  searchSeccionForm = new FormControl("");
  filteredIdSeccion: Observable<Array<any>>;

  errorRut: string = "";
  rut: string = "";
  resaltarError: boolean = true;

  renderTabla: boolean = true;
  listaReportes: Array<any> = [];
  funcionIntervalo: any;
  reporteEnProceso: boolean = false;
  tieneErrores: any = {};
  error: string = "";
  habilitarBtnGenerarReporte: boolean = false;

  parametrosForm = this.formBuilder.group({
    seccion: [""],
    rut: [""],
    anyo: ["0"],
    periodo: ["0"],
  });

  submitted: boolean = false;

  constructor(
    private _historico: HistoricoCalificacionesService,
    private formBuilder: FormBuilder
  ) {
    this.filteredIdSeccion = this.searchSeccionForm.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value || ""))
    );

    this.searchSeccionForm.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((res) => {
        this.filtroIdSeleccionado = 0;
        if (typeof res === "object") {
          let id = this.obtenerId(res);
          this.filtroIdSeleccionado = id;
        }
      });
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtOptionDefaultSearchLeftDesc };
    this.actualizarTabla();
  }

  private _normalizeValue(value: string): string {
    return value
      ?.toLowerCase()
      ?.normalize("NFD")
      ?.replace(/[\u0300-\u036f]/g, "");
  }

  private _filter(value: string) {
    if (typeof value != "string") {
      return [];
    }
    const filterValue = this._normalizeValue(value);
    return this.filtroIdSeccion.filter(
      (seccion: { descSeccion: string; id: number }) =>
        this._normalizeValue(String(seccion?.id))?.includes(filterValue)
    );
  }

  obtenerId(objeto: any): number {
    if (objeto.id) {
      return objeto.id;
    }
    return 0;
  }

  displayFn(objeto: any): string {
    return objeto && String(objeto.id)
      ? String(objeto.id).replace(/\w\S*/g, (w: string) =>
          w.replace(/^\w/, (c) => c.toUpperCase())
        )
      : "";
  }

  getAnyos(): void {
    this._historico.getFiltroAnhos(this.rutEstudiante).subscribe(
      (res: IListaAnhos) => {
        this.filtroAnyos = res.anyos;
      },
      (err: any) => {}
    );
  }

  getPeriodos(): void {
    if (this.filtroAnyoSeleccionado != 0) {
      this._historico
        .getFiltroPeriodo(this.rutEstudiante, this.filtroAnyoSeleccionado)
        .subscribe((res: IListaPeriodos) => {
          this.filtroPeriodos = res.periodos;
        });
    }
  }

  getIdSeccion(): void {
    this._historico
      .getFiltroIdSeccion(
        this.rutEstudiante,
        this.filtroAnyoSeleccionado,
        this.filtroPeriodoSeleccionado
      )
      .subscribe((res: any) => {
        this.filtroIdSeccion = res.secciones;
      });
  }

  validaRut() {
    if (this.rutEstudiante === "") {
      return;
    }
    this.getAnyos();
  }

  limpiarError(): void {
    setTimeout(() => {
      this.error = "";
    }, 10000);
  }

  fnErrorEnAutoCompletado(errorEnAutoCompletado: boolean): void {
    if (errorEnAutoCompletado) {
      this.error = "Debe seleccionar un ítem de la lista";
      this.limpiarError();
    }
  }

  busqueda(): void {
    this.submitted = true;
    let noTieneErrores = false;
    let errorEnAutoCompletado = false;
    noTieneErrores = this.fnNoTieneErrores()

    if (
      typeof this.searchSeccionForm.value !== "object" &&
      this.searchSeccionForm.value != ""
    ) {
      noTieneErrores = false;
      errorEnAutoCompletado = true;
      this.tieneErrores["seccion"] = true;
    }

    this.fnErrorEnAutoCompletado(errorEnAutoCompletado)
    if (noTieneErrores) {
      let body = {
        rut: this.rutEstudiante,
        anyo: this.filtroAnyoSeleccionado,
        periodoId: this.filtroPeriodoSeleccionado,
        idSeccion:
          this.filtroIdSeleccionado != 0 ? this.filtroIdSeleccionado : null,
      };
      this.renderTabla = false;
      this._historico.obtenerListadoReportes(body).subscribe({
        next: (res: IListaReportes) => {
          this.reporteEnProceso = false;
          if (res.error == null) {
            this.listaReportes = res.solicitudes;
            this.listaReportes.forEach((reporte) => {
              if (reporte.estadoProceso == "EP") {
                this.reporteEnProceso = true;
              }
            });
            this.renderTabla = true;
          }
        },
      });
    }
  }

  fnErroresGenerarSolicitud(): void {
    if (this.rutEstudiante == "") {
      this.tieneErrores["rut"] = true;
    }
    if (this.filtroAnyoSeleccionado == 0) {
      this.tieneErrores["anyo"] = true;
    }
    if (this.filtroPeriodoSeleccionado == 0) {
      this.tieneErrores["periodo"] = true;
    }
  }

  fnNoTieneErrores(): boolean {
    let noTieneErrores = false;
    if (
      this.filtroAnyoSeleccionado != 0 &&
      this.filtroPeriodoSeleccionado != 0 &&
      this.rutEstudiante != ""
    ) {
      noTieneErrores = true;
    } else {
      this.fnErroresGenerarSolicitud()
    }
    return noTieneErrores
  }

  generarSolicitudReporte(): void {
    this.submitted = true;
    let noTieneErrores = false;
    let errorEnAutoCompletado = false;
    noTieneErrores = this.fnNoTieneErrores()

    if (
      typeof this.searchSeccionForm.value !== "object" &&
      this.searchSeccionForm.value != ""
    ) {
      noTieneErrores = false;
      errorEnAutoCompletado = true;
      this.tieneErrores["seccion"] = true;
    }

    if (errorEnAutoCompletado) {
      this.error = "Debe seleccionar un ítem de la lista";
      this.limpiarError();
    }
    if (noTieneErrores) {
      let body = {
        rut: this.rutEstudiante,
        anyo: this.filtroAnyoSeleccionado,
        periodoId: this.filtroPeriodoSeleccionado,
        idSeccion:
          this.filtroIdSeleccionado != 0 ? this.filtroIdSeleccionado : null,
      };
      this.renderTabla = false;
      this._historico.generarSolicitudReporte(body).subscribe({
        next: (res: IListaReportes) => {
          this.reporteEnProceso = false;
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarError();
          } else {
            this.busqueda();
          }
        }
      });
    }
  }

  actualizarTabla(): void {
    this.funcionIntervalo = setInterval(() => {
      if (this.reporteEnProceso) {
        this.busqueda();
      }
    }, 35000);
  }

  seleccionFiltro(filtro: string): void {
    if (this.rutEstudiante == "") {
      return;
    }
    switch (filtro) {
      case "rut":
        this.getAnyos();
        this.limpiarFiltros("rut");
        this.tieneErrores["rut"] = false;
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
      case "anyo":
        this.getPeriodos();
        this.limpiarFiltros("anyo");
        this.tieneErrores["anyo"] = false;
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
      case "periodo":
        this.getIdSeccion();
        this.limpiarFiltros("periodo");
        this.tieneErrores["periodo"] = false;
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
      case "seccion":
        this.limpiarFiltros("seccion");
        this.tieneErrores["seccion"] = false;
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        if(this.error == "Debe seleccionar un ítem de la lista" ){
            this.error = "";
        }
        break;
      default:
        break;
    }
  }

  limpiarFiltros(filtro: string): void {
    this.reporteEnProceso = false;
    switch (filtro) {
      case "rut":
        this.filtroAnyos = [];
        this.filtroAnyoSeleccionado = 0;
        this.filtroPeriodoSeleccionado = 0;
        this.filtroPeriodos = [];
        this.filtroIdSeccion = [];
        this.searchSeccionForm.setValue("");
        this.filtroIdSeleccionado = 0;
        break;
      case "anyo":
        this.filtroPeriodoSeleccionado = 0;
        this.filtroPeriodos = [];
        this.filtroIdSeccion = [];
        this.searchSeccionForm.setValue("");
        this.filtroIdSeleccionado = 0;
        break;
      case "periodo":
        this.filtroIdSeccion = [];
        this.searchSeccionForm.setValue("");
        this.filtroIdSeleccionado = 0;
        break;
      case "seccion":
          break;
      default:
        this.rutEstudiante = "";
        this.filtroAnyos = [];
        this.filtroAnyoSeleccionado = 0;
        this.filtroPeriodoSeleccionado = 0;
        this.filtroPeriodos = [];
        this.filtroIdSeccion = [];
        this.searchSeccionForm.setValue("");
        this.filtroIdSeleccionado = 0;
        this.submitted = false;
        this.tieneErrores["anyo"] = false;
        this.tieneErrores["periodo"] = false;
        this.tieneErrores["rut"] = false;
        this.tieneErrores["seccion"] = false;
        this.renderTabla = true;
        setTimeout(() => {
          this.renderTabla = false;
        }, 50);
        this.listaReportes = [];
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar();
        break;
    }
  }

  activarBtnGenerar(): boolean {
    if (
      this.filtroAnyoSeleccionado == 0 ||
      this.filtroPeriodoSeleccionado == 0 ||
      this.rutEstudiante == ""
    ) {
      return false;
    }

    return true;
  }

  obtenerReporteExcel(idSolicitud: number): void {
    this._historico.obtenerReporteExcel(idSolicitud).subscribe(
      async (res: any) => {
        const contentDispositionHeader = res?.headers?.get('Content-Disposition')
        const fileName = contentDispositionHeader?.split(';')[1]?.trim()?.split('=')[1]
        const bufferPromise = await res?.body.arrayBuffer();
        const csvData = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), bufferPromise], {type: "text/plain;charset=utf-8"});
        saveAs(csvData, fileName?.replace(/"/g, '') ?? 'reporteHistorico.csv')
      }
    );
  }

  obtenerReportePDF(idSolicitud: number): void {
    this._historico.obtenerReportePDF(idSolicitud).subscribe(
      (res: any) => {
        const contentDispositionHeader = res?.headers?.get('Content-Disposition')
        const fileName = contentDispositionHeader?.split(';')[1]?.trim()?.split('=')[1]
        saveAs(res?.body, fileName?.replace(/"/g, '') ?? 'reporteHistorico.pdf')
      }
    );
  }
}
